/**
 * The supported languages in Appsemble Studio.
 */
export const supportedLanguages = {
  da: 'Danish (Dansk)',
  de: 'German (Deutsch)',
  fr: 'French (Français)',
  hr: 'Croatian (Hrvatski)',
  id: 'Indonesian (Indonesia)',
  nl: 'Dutch (Nederlands)',
  ru: 'Russian (русский)',
  en: 'English',
};

/**
 * The supported languages for administrative organization emails in Appsemble.
 */
export const supportedOrganizationLanguages = {
  nl: 'Dutch (Nederlands)',
  en: 'English',
};
